import CnpjUtils from "../../../shared/utils/CnpjUtils";

async function getVouchers(cnpj, laboratorio, rpl, codServico) {
  const labLimpo = CnpjUtils.cleanCnpj(laboratorio);
  const cnpjLimpo = CnpjUtils.cleanCnpj(cnpj);
  const requestOptions = {
    method: "GET",
    headers: {
      access_token: sessionStorage.getItem("token"),
      client_id: localStorage.getItem("clientid"),
      laboratorio: labLimpo,
    },
  };
  let status = "";

  let url = process.env.REACT_APP_ESSILOR_API +
    "gestao-pedidos-laboratorio/v1/pacto/vouchers?idCliente=" +
    cnpjLimpo +
    "&idLaboratorio=" +
    labLimpo +
    "&rpl=" +
    rpl;
  
  // Adiciona codServico apenas se tiver valor válido (não null, não undefined, não vazio)
  if (codServico !== null && codServico !== undefined && codServico !== "") {
    url += "&codServico=" + codServico;
  }
  
  return fetch(url, requestOptions)
    .then(response => {
      status = response.status;
      return response.json();
    })
    .then(json => {

      const response = {
        status: status,
        mensagem: status == 200 ? filtrarVouchersMaisAntigos(json): "erro",
      };

      return response;
    }).catch(error => {
      return []; 
    });;
}
export { getVouchers };

function filtrarVouchersMaisAntigos(data){
  return data.map(item => {
    const vouchersOrdenados = [...item.listaVouchers].sort((a, b) => new Date(a.dataCriacao) - new Date(b.dataCriacao));
    return {
      ...item,
      listaVouchers: vouchersOrdenados,
    };
  });
};
